<template>
    <nav v-if="manageStore.showNavbar" class="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm w-100">
        <div class="container-fluid">
            <RouterLink class="navbar-brand" to="/">
                <div class="shadow p-3 rounded logo-border">
                    <img width="250PX" src="../assets/images/wzl_navbar_logo.png" alt="">
                </div>
            </RouterLink>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav grid-container">
                    <li class="nav-item nav-1 mx-4">
                        <button type="button" class="btn btn-primary text-white"
                            @click="manageStore.loadDialog('UploadModal')">
                            <i class="bi bi-file-plus"></i> {{ manageStore.lang("navbar.newticket") }}
                        </button>
                    </li>
                    <div class="vr fw-bold"></div>
                    <li class="nav-item nav-2">
                        <RouterLink :class="'nav-link ' + (currentTab == '0' ? 'active' : '')" aria-current="page"
                            to="/tickets" @click="changeTab(0)">{{ manageStore.lang("navbar.ticket_overview") }}</RouterLink>
                    </li>
                    <li class="nav-item nav-3">
                        <RouterLink :class="'nav-link ' + (currentTab == '1' ? 'active' : '')" to="/printer"
                            @click="changeTab(1)">{{ manageStore.lang("navbar.printer_overview") }}</RouterLink>
                    </li>
                    <li class="nav-item nav-4 me-4">
                        <RouterLink :class="'nav-link ' + (currentTab == '2' ? 'active' : '')" to="/stats"
                            @click="changeTab(2)">{{ manageStore.lang("navbar.stats_overview") }}</RouterLink>
                    </li>
                    <div class="vr"></div>
                    <li class="nav-item nav-5 ms-4 me-3 gap-2">
                        <label class="fs-4 text-white">{{ manageStore.lang("navbar.filter") }}</label>
                        <select @change="filterChanged" v-model="manageStore.selectedFilter" class="form-select" aria-label="select filter">
                            <option v-for="m in manageStore.filterTypes" :key="m.index" :value="m">{{ m }}</option>
                        </select>
                    </li>
                    <li class="nav-item nav-6">
                        <select class="form-select" v-model="manageStore.localeLang" name="lang" id="lang">
                            <option value="en">en</option>
                            <option value="de">de</option>
                        </select>
                    </li>
                </ul>


                <div class="d-flex align-items-center flex-column gap-2 ms-auto">
                    <img class="rounded-circle" :src="manageStore.baseUserImageUrl + authStore.preferred_username"
                        width="60px" alt="">
                    <div>
                        <button @click="authStore.logout()" class="btn btn-primary text-white">{{
                            manageStore.lang("navbar.logout") }}</button>
                        <button @click="manageStore.loadDialog('SettingsModal')" class="btn text-white"><i
                                class="bi bi-gear fs-5"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
import { ref, defineProps } from 'vue';
import { useManageStore } from '@/stores/manage';
import { useAuthStore } from '@/stores/authStore';
import { useTicketsStore } from '@/stores/tickets';
/*eslint-disable*/
const props = defineProps({
    show: Boolean,
})
const manageStore = useManageStore();
const ticketStore = useTicketsStore();
const authStore = useAuthStore();
let currentTab = ref(0);

function changeTab(num) {
    currentTab.value = num;
}

function filterChanged(){
    ticketStore.fetchAllTickets();
}

</script>

<style scoped>
nav {
    background: linear-gradient(to bottom,
            #00549f,
            #79b2eb);
}

.nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-border {
    border-color: var(--bs-primary3);
    border-style: solid;
    border-width: 3px;
    background-color: #ffffff;
}

.form-select {
    width: auto;
    /* Adjust width to content */
}

@media (max-width: 991px) {

    .navbar-nav {
        margin-top: 1rem;
    }

    .grid-container {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .nav-1 {
        grid-column: 1;
        grid-row: 1;
    }

    .nav-2 {
        grid-column: 2;
        grid-row: 1;
    }

    .nav-3 {
        grid-column: 2;
        grid-row: 2;
    }

    .nav-4 {
        grid-column: 2;
        grid-row: 3;
    }

    .nav-5 {
        grid-column: 3;
        grid-row: 1;
    }

    .nav-6 {
        grid-column: 3;
        grid-row: 2;
    }
}
</style>